(() => {
  const modalWrapper = document.querySelector('[data-optispar-signup-modal]');
  if (!modalWrapper) return;

  const STORAGE_KEY = 'optispar_signup_modal_closed_at';
  const SUPPRESS_DAYS = 30;
  const SHOW_DELAY_MS = 1500;
  const ANIMATION_MS = 280;
  const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');

  const modal = modalWrapper.querySelector('.optispar-signup-modal__dialog');
  const closeButtons = modalWrapper.querySelectorAll('[data-optispar-modal-close]');
  const focusableSelectors =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  let previousActiveElement = null;

  const readStorage = () => {
    try {
      return Number(localStorage.getItem(STORAGE_KEY));
    } catch (error) {
      return 0;
    }
  };

  const writeStorage = () => {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (error) {
      // Ignore storage failures (private mode, blocked storage, etc.).
    }
  };

  const isSuppressed = () => {
    if (isDesignMode) return false;
    const closedAt = readStorage();
    if (!closedAt) return false;
    const suppressMs = SUPPRESS_DAYS * 24 * 60 * 60 * 1000;
    return Date.now() - closedAt < suppressMs;
  };

  const setAriaHidden = (hidden) => {
    modal.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  };

  const getFocusable = () => Array.from(modal.querySelectorAll(focusableSelectors));

  const trapFocus = (event) => {
    if (event.key !== 'Tab') return;

    const focusable = getFocusable();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
      return;
    }

    if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const closeModal = () => {
    if (modalWrapper.hidden) return;
    modalWrapper.hidden = true;
    modalWrapper.classList.remove('is-active');
    document.body.classList.remove('optispar-signup-modal-open');
    setAriaHidden(true);
    writeStorage();
    document.removeEventListener('keydown', handleKeydown);

    if (previousActiveElement) {
      previousActiveElement.focus();
      previousActiveElement = null;
    }
  };

  const startCloseAnimation = () => {
    if (modalWrapper.hidden || modalWrapper.classList.contains('is-closing')) return;
    modalWrapper.classList.add('is-closing');
    modalWrapper.classList.remove('is-active');
    setTimeout(() => {
      modalWrapper.classList.remove('is-closing');
      closeModal();
    }, ANIMATION_MS);
  };

  const handleKeydown = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      startCloseAnimation();
      return;
    }

    trapFocus(event);
  };

  const openModal = () => {
    if (isSuppressed()) return;

    previousActiveElement = document.activeElement;
    modalWrapper.hidden = false;
    modalWrapper.classList.add('is-active');
    modalWrapper.classList.remove('is-closing');
    document.body.classList.add('optispar-signup-modal-open');
    setAriaHidden(false);

    const focusable = getFocusable();
    const initialFocus = focusable[0] || modal;
    initialFocus.focus();

    document.addEventListener('keydown', handleKeydown);
  };

  closeButtons.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      startCloseAnimation();
    });
  });

  setTimeout(openModal, SHOW_DELAY_MS);
})();
